import { useState } from "react";

const FORM_ID = "newsletter-signup-footer";
const SUBMIT_ADDR = "https://readdy.ai/api/form/dahvtoboh653ivfvo6ng";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const honeypot = String(payload.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("Thank you for subscribing.");
      form.reset();
      return;
    }
    payload.delete("company_alt");

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      body.append(key, value.toString());
    });

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = String(serverMsg).toLowerCase().includes("spam");
      const okCode = parsed?.code === "OK";

      if (response.ok && okCode && !isSpam) {
        setStatus("success");
        setMessage("Thank you for subscribing. Welcome to Sofia Jewelry.");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "Something went wrong. Please try again.");
      }
    } catch {
      setStatus("error");
      setMessage("Network error. Please try again.");
    }
  };

  return (
    <form
      id={FORM_ID}
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <label htmlFor={`${FORM_ID}-email`} className="sr-only">
        Email address
      </label>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          id={`${FORM_ID}-email`}
          type="email"
          name="email"
          required
          autoComplete="email"
          placeholder="Enter your email"
          className="flex-1 bg-background-50/10 border border-background-50/25 text-background-50 placeholder:text-background-50/50 px-4 py-3 text-sm rounded-md focus:outline-none focus:border-primary-400 transition-colors"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-foreground-950 font-label text-xs tracking-[0.18em] uppercase px-6 py-3 rounded-md transition-colors cursor-pointer disabled:opacity-60"
        >
          {status === "loading" ? "Sending" : "Subscribe"}
        </button>
      </div>

      {/* Anti-spam field */}
      <input
        type="text"
        name="company_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="newsletter-extra-field"
      />

      {message && (
        <p
          className={`mt-3 text-xs ${
            status === "success" ? "text-primary-300" : "text-accent-300"
          }`}
        >
          {message}
        </p>
      )}
    </form>
  );
}